<template>
  <div>
    <h2>模拟面试</h2>
    <Table class="table" :columns="col" :data="data.list">
      <template slot-scope="{ row }" slot="number">
        {{ row._index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="teacher">
        {{ row.teacher_result.name }}
      </template>

      <template slot-scope="{ row }" slot="type">
        {{ row.type || "暂无" }}
      </template>
      <template slot-scope="{ row }" slot="date">
        {{ $moment(row.date).format("YYYY-MM-DD") }}
      </template>

      <template slot-scope="{ row }" slot="status">
        <template v-if="row.status == 1">已面试</template>
        <Button v-else type="primary" size="small" @click="editSimulation(row)"
          >面试</Button
        >
      </template>
    </Table>

    <Button type="dashed" class="add-btn" @click="editSimulation({})"
      >添加</Button
    >

    <h2 style="margin-top: 20px">学校面试</h2>

    <Table class="table" :columns="col2" :data="data2.list">
      <template slot-scope="{ row }" slot="number">
        {{ row._index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="school">
        {{
          row.school_result &&
          row.school_result.base_info &&
          row.school_result.base_info.chn_name
        }}
      </template>

      <template slot-scope="{ row }" slot="type">
        {{ row.type || "暂无" }}
      </template>
      <template slot-scope="{ row }" slot="date">
        {{ $moment(row.date).format("YYYY-MM-DD") }}
      </template>

      <template slot-scope="{ row }" slot="status">
        <template v-if="row.status == 1">已面试</template>
        <Button v-else type="primary" size="small" @click="editSimulation(row)"
          >面试</Button
        >
      </template>
    </Table>

    <Button type="dashed" class="add-btn" @click="editSimulation({})"
      >添加</Button
    >

    <Modal
      v-model="showEditSimulation"
      title="计划添加/修改"
      @on-ok="saveSimulation"
      @on-cancel="showEditSimulation = false"
    >
      <Form :model="editSimulationObj" label-position="left" :label-width="100">
        <FormItem label="Date">
          <DatePicker
            format="yyyy-MM-dd"
            type="date"
            v-model="editSimulationObj.date"
            placeholder="选择日期"
            style="width: 100%"
            @on-change="changeSimulationDate"
          ></DatePicker>
        </FormItem>
        <FormItem label="面试模式">
          <Select v-model="editSimulationObj.mode" style="width: 100%">
            <Option value="simulation">模拟</Option>
            <Option value="real">真实</Option>
          </Select>
        </FormItem>

        <FormItem label="面试学校">
          <Select
            v-model="editSimulationObj.student_school_selection_id"
            style="width: 100%"
          >
            <Option
              :value="item._id"
              v-for="item in schoolData.list"
              :key="item._id"
              >{{ item.school_result.base_info.chn_name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          label="面试老师"
          v-if="editSimulationObj.mode == 'simulation'"
        >
          <Select v-model="editSimulationObj.teacher_id" style="width: 100%">
            <Option
              :value="item._id"
              v-for="item in teacherData.list"
              :key="item._id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="方式">
          <Select v-model="editSimulationObj.type" style="width: 100%">
            <Option value="Reach">Reach</Option>
            <Option value="Fit">Fit</Option>
          </Select>
        </FormItem>

        <FormItem label="是否已面试">
          <i-switch
            v-model="editSimulationObj.status"
            :true-value="1"
            :false-value="0"
          />
          {{ editSimulationObj.status == 1 ? "已面试" : "未面试" }}
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      data2: {},
      col: [
        {
          title: "No.",
          slot: "number",
        },
        {
          title: "老师",
          slot: "teacher",
        },
        {
          title: "Type",
          slot: "type",
        },
        {
          title: "Date",
          slot: "date",
        },
        {
          title: "Status",
          slot: "status",
        },
      ],

      col2: [
        {
          title: "No.",
          slot: "number",
        },
        {
          title: "学校",
          slot: "school",
        },
        {
          title: "Type",
          slot: "type",
        },
        {
          title: "Date",
          slot: "date",
        },
        {
          title: "Status",
          slot: "status",
        },
      ],

      showEditSimulation: false,
      editSimulationObj: {},

      teacherData: {},
      schoolData: {},
    };
  },
  methods: {
    async getData(page = 1) {
      if (!this.$store.getters.selectedStudent._id) {
        return;
      }

      let res = await this.api({
        url: "/interview/select",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
          page: page,
          size: 10,
          mode: "simulation",
        },
      });

      this.data = res;
    },
    async getData2(page = 1) {
      if (!this.$store.getters.selectedStudent._id) {
        return;
      }

      let res = await this.api({
        url: "/interview/select",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
          page: page,
          size: 10,
          mode: "real",
        },
      });

      this.data2 = res;
    },
    setSimulationStatus(row) {
      console.log(row);
    },
    editSimulation(row) {
      console.log(row);
      this.showEditSimulation = true;
      this.editSimulationObj = row;
    },
    changeSimulationDate(val) {
      this.editSimulationObj.date = val;
    },
    async saveSimulation() {
      await this.api({
        url: "/interview/save",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
        },
        data: {
          _id: this.editSimulationObj._id,
          mode: this.editSimulationObj.mode,
          type: this.editSimulationObj.type,
          date: this.$moment(this.editSimulationObj.date).format("YYYY-MM-DD"),
          status: this.editSimulationObj.status == 1 ? 1 : 0,
          teacher_id: this.editSimulationObj.teacher_id,
          student_school_selection_id:
            this.editSimulationObj.student_school_selection_id,
          student_id: this.$store.getters.selectedStudent._id,
        },
      });
      this.$Message.success("保存成功");
      this.getData();
      this.getData2();
    },

    async getAllTeacher(page = 1) {
      let res = await this.api({
        url: "/teacher/select",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          page: page,
          size: 10,
        },
      });

      this.teacherData = res;
    },

    async getSchoolSelection(page = 1) {
      if (!this.$store.getters.selectedStudent._id) {
        return;
      }

      let res = await this.api({
        url: "/school/selectSelection",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
          page: page,
          size: 99,
        },
      });

      this.schoolData = res;
    },
  },
  mounted() {
    this.getAllTeacher();
    this.getData();
    this.getData2();
    this.getSchoolSelection();
  },
};
</script>

<style lang="less" scoped>
.table {
  margin-top: 10px;
}

.add-btn {
  margin-top: 10px;
}
</style>